import Header from "./component/Header/Header";

import TopHead from "./component/Top-head/TopHead";

import Footer from "./component/Footer/News/Footer/Footer";
import { Outlet } from "react-router-dom";

import { SnackbarProvider } from "notistack";
import ConactsWidget from "./component/Contact-widget/Contact-widget";
import { Divider } from "@mui/material";

function App() {
  return (
    <SnackbarProvider>
      <div className="w-full md:pb-36 lg:pb-0 overflow-hidden">
        <div className="fixed z-[200] w-full">
          <TopHead />
          <Header />
          <Divider />
        </div>
        <div>
          <Outlet />
        </div>

        <Footer />
        <ConactsWidget />
      </div>
    </SnackbarProvider>
  );
}

export default App;
